import PropTypes from 'prop-types';
import React from 'react';
import ContentLoader from 'react-content-loader';

import Theme from 'styles/theme';

const YPOS = Theme.get('spacing') * 4;
const HEIGHT = 30;
const WIDTH = 250;
const BOXSIZE = 30;

const Title = () => <rect x="0" y={Theme.get('spacing') * 2} width="200" height="25" />;
const Checkbox = ({ yPos }) => <rect x="0" y={yPos} width={BOXSIZE} height={BOXSIZE} />;
const Text = ({ yPos }) => <rect x="55" y={yPos} width={WIDTH} height={HEIGHT} />;

const Placeholder = () => (
  <div className="Placeholder">
    <ContentLoader
      height={Theme.get('spacing') * 40}
      primaryColor={Theme.get('colors-grey')}
      secondaryColor={Theme.get('colors-grey')}
    >
      <Title />
      <Checkbox yPos={YPOS * 3} />
      <Text yPos={YPOS * 3} />
      <Checkbox yPos={YPOS * 5} />
      <Text yPos={YPOS * 5} />
      <Checkbox yPos={YPOS * 7} />
      <Text yPos={YPOS * 7} />
      <Checkbox yPos={YPOS * 9} />
      <Text yPos={YPOS * 9} />
    </ContentLoader>
  </div>
);

Checkbox.propTypes = { yPos: PropTypes.number.isRequired };

Text.propTypes = { yPos: PropTypes.number.isRequired };

Placeholder.propTypes = {};

Placeholder.defaultProps = {};

export default Placeholder;
